<template>
  <div class="content">
    <div ref="tablePanel" class="fullheight">
      <div class="top_search">
        <el-row style="height: 100%; width: 100%">
          <el-col :span="7" class="col_style" :offset="10">
            <p>订单日期：</p>
            <el-date-picker
              v-model="dateRangeVal"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="loadData(true)"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6" class="col_style" :offset="1">
            <el-input v-model="code" placeholder="请输入订单号,客户名称搜索" suffix-icon="el-icon-search" @keyup.enter.native="loadData(true)">
              <!-- <el-button slot="append" type="primary" @click="loadData(true)"
                >搜索</el-button
              > -->
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="searchPart">
        <el-tabs v-model="activeName" @tab-click="handleTab">
          <el-tab-pane v-for="item in tabList" :key="item.index" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="activeName != 2">
        <el-table
          ref="ecoTable"
          :style="{
            height: `${tableMaxHeight}` + 'px'
          }"
          :max-height="tableMaxHeight"
          :data="tableData"
          class="tablePart"
          border
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="order_no" label="订单编号" key="0" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="orderRecord(scope.row.refId)">{{ scope.row.order_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="order_time" key="0" label="订单日期" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="customer_name" key="0" label="客户名称" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="account_name" key="0" label="产品名称" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="order_amount" key="0" label="订单金额" :formatter="num_formatter" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column key="0" prop="order_status" label="订单状态" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{
                scope.row.order_status == 0
                  ? '已取消'
                  : scope.row.order_status == 1
                  ? '待确认'
                  : scope.row.order_status == 2
                  ? '待付款'
                  : scope.row.order_status == 3
                  ? '已付款'
                  : scope.row.order_status == 4
                  ? '付款已确认'
                  : scope.row.order_status == 5
                  ? '待开票'
                  : scope.row.order_status == 6
                  ? '已开票'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column key="0" prop="payment_no" label="付款单号" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="paymentRecord(scope.row.payment_id, scope.row.order_status)">{{
                scope.row.payment_no
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="payment_time" key="0" label="付款单日期" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="payment_amount" label="付款单金额" key="0" :formatter="num_formatter" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="payment_status" label="付款状态" key="0" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{
                scope.row.payment_status == 0
                  ? '已取消'
                  : scope.row.payment_status == 1
                  ? '待确认'
                  : scope.row.payment_status == 2
                  ? '待付款'
                  : scope.row.payment_status == 3
                  ? '已付款'
                  : scope.row.payment_status == 4
                  ? '付款已确认'
                  : scope.row.payment_status == 5
                  ? '待开票'
                  : scope.row.payment_status == 6
                  ? '已开票'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_amount" key="0" label="实际收款" :formatter="num_formatter" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column label="维护状态" :show-overflow-tooltip="true">
            <template>
              {{ activeName == 0 ? '待维护' : activeName == 1 ? '已维护' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="maintain_no" label="维护记录" key="0" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showDialog(scope.row.id)">{{ scope.row.maintain_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" v-if="activeName == 0">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleClick(scope.row)">维护</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <el-table
          :style="{
            height: `${tableMaxHeight}` + 'px'
          }"
          border
          :max-height="tableMaxHeight"
          ref="ecoTable"
          :data="tableData"
          class="tablePart"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column key="1" prop="maintain_no" label="记录编号" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showDialog(scope.row.id)">{{ scope.row.maintain_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="customer_name" key="1" label="客户名称" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="order_no" label="订单编号" key="1" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="orderRecord(scope.row.refId)">{{ scope.row.order_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="payment_no" key="1" label="付款单号" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="paymentRecord(scope.row.payment_id, scope.row.order_status)">{{
                scope.row.payment_no
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="account_name" key="1" label="产品名称" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column key="1" prop="createByName" label="编制人" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column key="1" prop="createTime" label="维护时间" :show-overflow-tooltip="true"> </el-table-column>
        </el-table>
      </div>
      <div class="center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>

      <!-- 维护页面 -->
      <maintain-bill-order :detailId="insertId" :refId="refId" :show="showDetailEdit" @closeDetailDialog="closeDetailDialogEdit" />
      <!-- 维护详情 -->
      <maintain-bill-detail :detailId="detailId" :show="showDetail" @closeDetailDialog="closeDetailDialog" />
    </div>
    <!-- 订单详情 -->
    <order-record :show="showOrderRecord" :orderId="orderId" @closeOrderRecord="closeOrderRecord"> </order-record>
    <!-- 付款记录 -->
    <payment-record :show="showPaymentRecord" :paymentId="paymentId" :isCancle="isCancle" @closePaymentRecord="closePaymentRecord"> </payment-record>
  </div>
</template>

<script>
import utils from '@/utils.js'
import MaintainBillOrder from './maintainCenter/maintainBillOrder.vue'
import MaintainBillDetail from './maintainCenter/maintainBillDetail.vue'
import PaymentRecord from './billingCenter/paymentRecord.vue'
import OrderRecord from './billingCenter/orderRecord.vue'
import moment from 'moment'
export default {
  components: {
    MaintainBillDetail,
    PaymentRecord,
    OrderRecord,
    MaintainBillOrder
  },
  data() {
    return {
      isCancle: false,
      showPaymentRecord: false,
      paymentId: '',
      showOrderRecord: false,
      orderId: '',
      refId: '',
      tableMaxHeight: document.body.clientHeight - 200,
      code: '',
      dateRangeVal: [],
      activeName: '0',
      tabList: [
        {
          label: '待维护',
          name: '0'
        },
        {
          label: '已维护',
          name: '1'
        },
        {
          label: '维护记录',
          name: '2'
        }
      ],
      detailId: '',
      showDetail: false,
      insertId: '',
      showDetailEdit: false,
      tableData: [],
      searchDateRange: '',
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.ecoTable.doLayout()
          })
        }
      }
    }
  },
  mounted() {
    this.loadData()
    this.calcTableHeight()
  },
  methods: {
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
      if (column.type == 'selection') obj.textAlign = 'center'
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:left'
        }
      } else {
        return 'text-align:center'
      }
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    // 获取tab数字
    getNum(param) {
      this.$http.post('${third}/costcenter/third_maintain/queryCount', param).then(
        (resp) => {
          if (resp.data) {
            this.tabList = [
              {
                label: '待维护' + '(' + resp.data.wait_maintain_count + ')',
                name: '0'
              },
              {
                label: '已维护' + '(' + resp.data.already_maintain_count + ')',
                name: '1'
              },
              {
                label: '维护记录' + '(' + resp.data.maintain_count + ')',
                name: '2'
              }
            ]
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // tab切换
    handleTab(tab, event) {
      this.activeName = tab.index
      this.currentPage = 1
      this.loadData()
      this.calcTableHeight(500)
    },
    // 关闭详情对话框
    closeDetailDialog() {
      this.showDetail = false
    },
    //订单付款记录关闭
    closePaymentRecord() {
      this.showPaymentRecord = false
    },
    //订单付款记录
    paymentRecord(id, status) {
      this.isCancle = false
      this.paymentId = ''
      if (id) {
        this.paymentId = id
      }
      if (status == '3') {
        this.isCancle = true
      }
      this.showPaymentRecord = true
    },
    //订单详情
    orderRecord(id) {
      this.orderId = ''
      if (id) {
        this.orderId = id
      }
      this.showOrderRecord = true
    },
    // 关闭维护对话框
    closeDetailDialogEdit(data) {
      this.showDetailEdit = false
      if (data) {
        this.currentPage = 1
        this.loadData()
      }
    },
    //订单详情关闭
    closeOrderRecord() {
      this.showOrderRecord = false
    },
    // 获取列表数据
    loadData(isSearch) {
      this.tableData = []
      if (isSearch) this.currentPage = 1
      const params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: this.total
        },
        querys: []
      }
      if (this.dateRangeVal && this.dateRangeVal.length) {
        params.querys.push({
          group: 'advance',
          operation: 'BETWEEN',
          property: 'third_order.order_time',
          relation: 'AND',
          value: this.dateRangeVal
        })
      }
      if (this.code) {
        params.querys.push(
          {
            group: 'quick',
            operation: 'LIKE',
            property: 'third_order.order_no',
            relation: 'OR',
            value: this.code
          },
          {
            group: 'quick',
            operation: 'LIKE',
            property: 'third_maintain.customer_name',
            relation: 'OR',
            value: this.code
          }
        )
      }
      this.getNum(JSON.parse(JSON.stringify(params)))
      switch (this.activeName) {
        case '0':
          params.querys.push({
            group: 'advance',
            operation: 'EQUAL',
            property: 'third_order.maintain_status',
            relation: 'AND',
            value: 0
          })
          break
        case '1':
          params.querys.push({
            group: 'advance',
            operation: 'EQUAL',
            property: 'third_order.maintain_status',
            relation: 'AND',
            value: 1
          })
          break
        case '2':
          params.querys.push({
            group: 'advance',
            operation: 'NOTNULL',
            property: 'third_maintain.maintain_no',
            relation: 'AND'
          })
          break
      }

      this.$http.post('${third}/costcenter/third_maintain/query', params).then(
        (resp) => {
          let response = resp.data
          if (response) {
            this.tableData = response.rows
            this.currentPage = response.page
            this.pageSize = response.pageSize
            this.total = response.total
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 维护
    handleClick(item) {
      this.insertId = item.id
      this.refId = item.refId
      this.showDetailEdit = true
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 千分位格式化
    num_formatter(row, column, cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },
    // 年月日转化
    month_formatter(row, column, cellValue) {
      if (cellValue) {
        return moment(cellValue).format('YYYY-MM-DD')
      }
    },
    // 详情页面弹出
    showDialog(id) {
      this.showDetail = true
      this.detailId = id
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100% - 20px);
  position: relative;
}
.tablePart {
  width: 100%;
}
.center {
  text-align: right;
  margin-top: 13px;
}
/deep/td:first-child .cell {
  padding-left: 14px !important;
}
.top_search {
  height: 45px;
  width: 100%;
  position: absolute;
  top: 0;
  right: 20px;
  display: flex;
  align-items: center;
  z-index: 2;
  margin-bottom: 10px;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0px 0px 5px 0px;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
  p {
    flex-shrink: 0;
  }
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.searchPart {
  margin-bottom: 10px;
}
</style>
